<div id="site_wrapper">
    <div class="contenedor-principal">
        <div class="row mapa-sitio">
            <div class="col-12">
                <h2>SEGURIDAD: VISITA DE CERTIFICACIÓN</h2> 
            </div>
        </div>
        <div class="row filtros">
            <div class="col-sm-12 col-md-6 col-lg-3">
                <label>ACTIVOS/INACTIVOS</label>
                <select [(ngModel)]="filter.eliminado" class="form-control">
                    <option value="2">TODOS</option>
                    <option value="0">ACTIVOS</option>
                    <option value="1">INACTIVOS</option>
                </select>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
                <button class='btn btn-danger btn-fluid' type='button' style='margin-top: 31px;' (click)="getRegistros()">
                    Filtrar
                </button>
            </div>
        </div>
        
        <div class="row tabla-catalogo">  
            <div class="col-12">
                <table class="table table-responsive table-sm table-hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"> 
                    <thead>
                        <tr>
                            <th width="10%">Línea Transportista</th>
                            <th width="10%">SPN</th>
                            <th width="30%">Estatus Certificación</th>
                            <th width="30%">No. Proceso</th>
                            <th width="30%">No. Certificación</th>
                            <th width="30%">Nivel de Seguridad</th>
                            <th width="30%">No. de Vuelta</th>
                            <th width="30%">Inicio Certificación</th>
                            <th width="30%">Cierre Certificación</th>
                            <th width="30%">ACTIVOS/INACTIVOS</th>
                            <th width="30%">MOTIVO LINEA EN PROCESO / DECLINADO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let group of datos;">
                            <td>{{group.Nombre}}</td>
                            <td>{{group.SPN}}</td>
                            <td>{{group.EstatusCertificacion}}</td>
                            <td>{{group.NoProceso}}</td>
                            <td>{{group.NoCertificacion}}</td>
                            <td>{{group.NivelSeguridad}}</td>
                            <td>{{group.NoVuelta}}</td>
                            <td>{{group.InicioCertificacion}}</td>
                            <td>{{group.CierreCertificacion}}</td>
                            <td>{{group.EliminadoValue}}</td>
                            <td>{{group.Motivo}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>             
        </div>
    </div>
</div>

<app-loading-efect></app-loading-efect>